import "./SystemsList.css";
import { ActionButton, css, Icon } from "office-ui-fabric-react";
import { SourceType, SourceType_ } from "../../../store/ExternalEpmConnectStore";
import { System } from "./common";

type SystemButtonProps = {
    key?: string;
    system: System,
    isSelected: boolean;
    onSelect: () => void;
    text?: string;
    iconName?: string;
}

export const SystemButton = (props: SystemButtonProps) =>
    <ActionButton
        key={props.key ?? props.system.type?.toString()}
        title={props.system.isUnavailable && props.system.type !== SourceType.Spo ? "This feature is included in Enterprise plan" : undefined}
        disabled={props.system.isDisabled}
        className={css('system-connect-button',
            props.isSelected ? "selected" : "",
            props.system.isDisabled ? "disabled" : "",
            props.system.isUnavailable ? "unavailable" : "")}
        iconProps={{
            iconName: props.iconName ?? (props.system.type ? SourceType_.getIconName(props.system.type) : undefined),
            className: "system-logo"
        }}
        onClick={() => props.onSelect()}
    >
        <div className="connection-row">
            <div className="connection-details">
                <div className="system-name">{props.text ?? props.system.text ?? (props.system.type ? SourceType_.getName(props.system.type) : "")}</div>
                {props.system.isConnected === undefined
                    ? undefined
                    : props.system.isConnected
                        ? <div className="connection-status ok">
                            Linked <Icon iconName="Accept" />
                        </div>
                        : <div className="connection-status">Not Linked</div>
                }
            </div>
            {props.system.isUnavailable && props.system.type !== SourceType.Spo && <Icon className="upgrade-icon" iconName="PPMXUpSolid" />}
        </div>
    </ActionButton>;
